<div *ngIf="translationLoaded" class="generic-wrapper-app page mat-typography">
  <df-header-app *ngIf="showHeader"></df-header-app>

  <div #pageBody id="pageBody" class="page-body">
    <router-outlet></router-outlet>
  </div>

</div>
